export const PRODUCT_SUBSCRIPTION_STATUS = {
  SUBSCRIBED: "SUBSCRIBED",
  UNSUBSCRIBED: "UNSUBSCRIBED",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  REJECTED: "REJECTED",
} as const;

export type ProductSubscriptionStatus =
  (typeof PRODUCT_SUBSCRIPTION_STATUS)[keyof typeof PRODUCT_SUBSCRIPTION_STATUS];
